import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import slick from 'slick-carousel';
import WOW from 'wowjs';

$(() => {
	svg4everybody();

	$('.nav__link').on('click', function () {
		const $target = $(this).data('target');

		if (!$target) { return; }

		$('html, body').animate({
			scrollTop: $(`[data-section="${$target}"]`).offset().top
		}, 500);

		if ($('body').hasClass('show-menu')) {
			$('body').removeClass('show-menu');
		}
	});

	$('.js-nav').on('click', function () {
		const $body = $('body');
		const $header = $('.header');
		const $nav = $('.nav');

		$nav.css({top: $header.height()});

		if ($body.hasClass('show-menu')) {
			$body.removeClass('show-menu');
		} else {
			$body.addClass('show-menu');
		}
	});

	$('.js-slider').slick({
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});

	const wow = new WOW.WOW({
		boxClass: 'wow'
	});

	wow.init();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js